import Link from 'next/link';
import classNames from 'classnames';
import { IResortPathInfo } from 'api/resort/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { Routes } from 'routes';
import { useSettingsPrefetch } from 'settings/SettingsContext';
import styles from './styles.module.scss';

export const ResortNearby = (
  { links, className }: { className?: string, links: IResortPathInfo[] },
) => {
  const prefetch = useSettingsPrefetch();
  const { t } = useOTSTranslation('common');
  return (
    <div className={classNames(styles.box, className)}>
      <div>
        {t('common.nearbyResorts')}
      </div>
      {links.map((l) => (
        <Link scroll={false} href={Routes.resortSnowReport(l)} key={l.uuid} prefetch={prefetch}>
          <a href={Routes.resortSnowReport(l)}>
            {l.title_short || l.title}
          </a>
        </Link>
      ))}
    </div>
  );
};
